
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.11 8.79c.39-.437.39-1.147 0-1.584l-4-4.478a.928.928 0 00-1.416 0 1.218 1.218 0 000 1.585l2.293 2.567H1.402c-.553 0-1 .5-1 1.12 0 .62.447 1.12 1 1.12h11.585l-2.293 2.567a1.218 1.218 0 000 1.585.928.928 0 001.415 0l4-4.478v-.003z","fill":"#313131"}})])
          )
        }
      }
    